import { DynamicLoad } from '@/_cactus_core/build/dynamicLoad';





import a3f841cc826ba35479ea0441c34c6a51eb from "./generated-c0e60e9c-99ba-4d11-92a3-68aca2e06863.json";

import a1da61ff00326341f86930b40e30e6415b from "./generated-3f6ccdb9-69c1-431c-82f4-a513270d36e2.json";

import a86b5f3a4585f140aa12ca47c99885f38b from "./generated-42ec40b2-10e8-4ad9-a7be-a0542b96c6a6.json";

import a50c3307a79ec4eff7345d06503d31ce5b from "./generated-c4e3a070-e932-440f-9433-04d47e10e388.json";

import a3c5d4fd500f03d9e3f16bd3d6047819cb from "./generated-b66aff52-8d11-4b3b-a308-a70f7530848d.json";

import a71f829466075c913c194eee01e08d034b from "./generated-bf89231a-8128-47a8-9dbb-b3ed32ade7de.json";

import aa5ce5593caada4343cdc582fdaa5eecdb from "./generated-57691df4-ef52-4d24-bb09-71b91c18ff6a.json";

import a6070fc6de4c462a479a114bcf124cbc1b from "./generated-bed852da-0a0f-4fcd-b41a-3b4cd6cefc04.json";

import a762bb23bcf9bc144956f943417209f0bb from "./generated-603e228c-7070-42fb-b9b9-45fe0c1c74dc.json";

import a4f4e77560b8dbc46a6fab5990de96699b from "./generated-f81cd881-8858-4c47-9402-c88591f19a30.json";

import adb93eda13e619df3bfd5ba6b3fd00715b from "./generated-a8fab829-af61-4531-aed5-bd8b1501d47b.json";

import a5ad65e2c3ae95f3967653d72c2bb9da3b from "./generated-503003f3-61ad-48c2-9f20-cf2b4d990b63.json";

import a6f3994c8ba19051c1e51fc166492c045b from "./generated-5d23e9fa-217f-4298-b589-ab751c484d34.json";

import afae36abbc9272a819218e368e09faec8b from "./generated-e15d3331-d068-4818-b27e-4e28300c2e65.json";

import aa533ffdbc6e44a7fa5f5063b07fdcba1b from "./generated-a7d7018b-290d-4167-9b6d-5c8858d8d6f8.json";

import aa7c0ed50be775b67b8a41dbd89033a96b from "./generated-7d80fa99-1db5-40a9-aef6-6b72068bf69e.json";

import acb93566f03468dfa408a555d8e617d70b from "./generated-4a8885bf-c764-4418-87c5-336ae261638f.json";





/* eslint-disable */

export default async function(url) {
  let storeData = false;

  async function direct(jsonResult) {
    return new Promise(async function(done,err) {
      try {
        storeData = {
          headers: jsonResult.headers,
          data: jsonResult.data,
        };
        
        done(storeData);
      } catch(e) {
        err(e);
      }
    });
  }

  async function ok(cachedJson) {
    return new Promise(async function(done,err) {
      try {
        const jsonResult = await DynamicLoad(cachedJson);

        storeData = {
          headers: jsonResult.headers,
          data: jsonResult.data,
        };

        done(storeData);
      } catch(e) {
        err(e);
      }
    });
  }
  
  try {
  
  




         if(url === "/api/appearance"){
            
                    await direct(a3f841cc826ba35479ea0441c34c6a51eb);
                
        }
    


        else if(url === "/api/getlegalterm"){
            
                    await direct(a1da61ff00326341f86930b40e30e6415b);
                
        }
    


        else if(url === "/api/country"){
            
                    await direct(a86b5f3a4585f140aa12ca47c99885f38b);
                
        }
    


        else if(url === "/api/crypto/all"){
            
                    await direct(a50c3307a79ec4eff7345d06503d31ce5b);
                
        }
    


        else if(url === "/api/bff/features"){
            
                    await direct(a3c5d4fd500f03d9e3f16bd3d6047819cb);
                
        }
    


        else if(url === "/api/payment-providers"){
            
                    await direct(a71f829466075c913c194eee01e08d034b);
                
        }
    


        else if(url === "/api/bff/games/top-wins"){
            
                    await direct(aa5ce5593caada4343cdc582fdaa5eecdb);
                
        }
    


        else if(url === "/api/bff/games/last-wins"){
            
                    await direct(a6070fc6de4c462a479a114bcf124cbc1b);
                
        }
    


        else if(url === "/api/casino-games/filter?categories[]=jogos-da-pg&per_page=15"){
            
                    await direct(a762bb23bcf9bc144956f943417209f0bb);
                
        }
    


        else if(url === "/api/casino-games/filter?categories[]=roleta&per_page=16"){
            
                    await direct(a4f4e77560b8dbc46a6fab5990de96699b);
                
        }
    


        else if(url === "/api/undefined&per_page=undefined"){
            
                    await direct(adb93eda13e619df3bfd5ba6b3fd00715b);
                
        }
    


        else if(url === "/api/casino-games/filter?categories[]=jogos-crash&per_page=15"){
            
                    await direct(a5ad65e2c3ae95f3967653d72c2bb9da3b);
                
        }
    


        else if(url === "/api/casino-games/filter?categories[]=jogos-de-aventura&per_page=15"){
            
                    await direct(a762bb23bcf9bc144956f943417209f0bb);
                
        }
    


        else if(url === "/api/casino-games/filter?categories[]=cassino-ao-vivo&per_page=15"){
            
                    await direct(a6f3994c8ba19051c1e51fc166492c045b);
                
        }
    


        else if(url === "/api/casino-games/filter?categories[]=slots&per_page=15"){
            
                    await direct(afae36abbc9272a819218e368e09faec8b);
                
        }
    


        else if(url === "/api/casino-games/filter?categories[]=jogos-novos&per_page=15"){
            
                    await direct(a762bb23bcf9bc144956f943417209f0bb);
                
        }
    


        else if(url === "/api/casino-games/filter?per_page=1&per_page=15"){
            
                    await direct(aa533ffdbc6e44a7fa5f5063b07fdcba1b);
                
        }
    


        else if(url === "/api/casino-games/filter?providers[]=hacksaw&per_page=15"){
            
                    await direct(aa7c0ed50be775b67b8a41dbd89033a96b);
                
        }
    


        else if(url === "/api/casino-games/filter?categories[]=blackjack&per_page=15"){
            
                    await direct(acb93566f03468dfa408a555d8e617d70b);
                
        }
    


        else if(url === "/api/casino-games/filter?categories%5B%5D=all"){
            
                    await direct(aa533ffdbc6e44a7fa5f5063b07fdcba1b);
                
        }
    





  } catch(ex){
    console.log('failed to get cache',ex,url);
  }

  return storeData;
};

/* eslint-enable */